import { getKindergartenByIdRequest } from "@/helpers/api/kindergartens";

/**
 * Resolves physical object id for cards list on object pages.
 * Same logic as fetchObjectCardsList — kindergarten org → object.id.
 *
 * @param {{ getObjectInfo: { results: { organization?: number|string } } }} getters
 * @returns {Promise<number|string|null>}
 */
export async function resolveObjectIdForCardsList(getters) {
  const organizationId = getters.getObjectInfo?.results?.organization;

  if (!organizationId) {
    return null;
  }

  const kindergarten = (
    await getKindergartenByIdRequest({ id: organizationId })
  ).data;

  return kindergarten?.object?.id ?? null;
}
